import { Field, TextInput, SelectInput } from "@/components/setup/SetupField";

const CCHBC_MARKETS = [
  "Armenia", "Austria", "Bosnia & Herzegovina", "Bulgaria", "Croatia", "Cyprus",
  "Czech Republic", "Egypt", "Estonia", "Greece", "Hungary", "Ireland", "Italy",
  "Kosovo", "Latvia", "Lithuania", "Moldova", "Montenegro", "Nigeria",
  "North Macedonia", "Northern Ireland", "Poland", "Romania", "Serbia",
  "Slovakia", "Slovenia", "Switzerland", "Ukraine", "Other",
];

export { CCHBC_MARKETS };

export const StepMarket = ({ form, update, errors }) => (
  <div className="space-y-6" data-testid="setup-step-market">
    <Field label="Country / Market" required error={errors.country} testId="setup-field-country">
      <SelectInput
        options={CCHBC_MARKETS}
        placeholder="Select your market…"
        value={form.country}
        error={errors.country}
        onChange={(e) => update({ country: e.target.value })}
        data-testid="setup-input-country"
      />
    </Field>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label="BU Owner — Name" required error={errors.bu_owner_name} testId="setup-field-bu-owner-name">
        <TextInput
          value={form.bu_owner_name}
          error={errors.bu_owner_name}
          onChange={(e) => update({ bu_owner_name: e.target.value })}
          placeholder="e.g. Ana Kovač"
          data-testid="setup-input-bu-owner-name"
        />
      </Field>
      <Field label="BU Owner — Email" required error={errors.bu_owner_email} testId="setup-field-bu-owner-email">
        <TextInput
          type="email"
          value={form.bu_owner_email}
          error={errors.bu_owner_email}
          onChange={(e) => update({ bu_owner_email: e.target.value })}
          placeholder="name@cchellenic.com"
          data-testid="setup-input-bu-owner-email"
        />
      </Field>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label="IT Liaison — Name" hint="Optional — your BU IT contact for integrations & SSO" testId="setup-field-it-name">
        <TextInput
          value={form.it_liaison_name}
          onChange={(e) => update({ it_liaison_name: e.target.value })}
          placeholder="Optional"
          data-testid="setup-input-it-name"
        />
      </Field>
      <Field label="IT Liaison — Email" testId="setup-field-it-email">
        <TextInput
          type="email"
          value={form.it_liaison_email}
          onChange={(e) => update({ it_liaison_email: e.target.value })}
          placeholder="Optional"
          data-testid="setup-input-it-email"
        />
      </Field>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label="Local SPOC — Name" hint="Optional — day-to-day programme contact in your BU" testId="setup-field-spoc-name">
        <TextInput
          value={form.spoc_name}
          onChange={(e) => update({ spoc_name: e.target.value })}
          placeholder="Optional"
          data-testid="setup-input-spoc-name"
        />
      </Field>
      <Field label="Local SPOC — Email" testId="setup-field-spoc-email">
        <TextInput
          type="email"
          value={form.spoc_email}
          onChange={(e) => update({ spoc_email: e.target.value })}
          placeholder="Optional"
          data-testid="setup-input-spoc-email"
        />
      </Field>
    </div>
  </div>
);
